import { Component, OnInit, Input } from '@angular/core';
import { LoginService } from "../../../injections/login.service";
import { Router } from "@angular/router";
import { LoaderService } from "../../../common/loadingBar/loader.service";

@Component({
    selector: 'main-login',
    templateUrl: '../templates/main-login.html'
})

export class MainLoginComponent implements OnInit {
   
    public loginState: string = "login";
    public loginError: boolean = false;
    constructor(private loginS: LoginService, private _router: Router, private _loader: LoaderService) {}

    public changeState(event){
        this.loginState = event;
    }

    public sendDataLogin(data){
        this._loader.show();
        this.loginS.login(data).subscribe(
            res => {
                //console.log(res);
                this._loader.hide();
                this.loginS.setLoginTrue(true);
                this._router.navigate(['/services']);
            },
            err => {
                //console.log(err);
                this._loader.hide();
                this.loginError = true;
            },
            () => {}
        )
    }

    ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/app/modules/login/components/main-login.component.ts